export default __webpack_public_path__ + "images/8309d0fc55992e28f04edd815e2b63c0-festival.jpg";